export type SaleTabKey = 'live' | 'inbox' | 'post' | 'auto' | 'waiting';

export type SidebarTabKey = Exclude<SaleTabKey, 'auto'>;

export type SidebarTab = {
  key: SidebarTabKey;
  label: string;
};

export const SIDEBAR_TABS: SidebarTab[] = [
  { key: 'live', label: 'Live' },
  { key: 'inbox', label: 'Inbox' },
  { key: 'post', label: 'Post' },
  { key: 'waiting', label: 'Queue' },
];
